// hooks/useAtualizarDados.ts
import { useState } from "react";
import { Parceiro } from "../../../interfaces/Parceiro";
import { atualizarParceiroService } from "../../../services/atualizarParceiroService";

export const useAtualizarParceiro = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const atualizar = async (parceiroId: number, parceiroData: Parceiro) => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const cadastrarDados = await atualizarParceiroService(
        parceiroId,
        parceiroData
      );

      if (cadastrarDados) {
        setSuccess("Parceiro atualizado com sucesso!");
      } else {
        setError(
          "Não foi possível atualizar o parceiro, por favor tente novamente!"
        );
      }
    } catch (error) {
      setError(`Não foi possível atualizar o parceiro,${error}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizar,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
